import React from 'react';
import {Box, Stack} from '@mui/material';
import {Button} from '@lightricks/react-design-system';
import {ButtonProps} from '@lightricks/react-design-system/dist/components/button/ButtonProps';
import {ActionItem, ActionsDisplay} from './ActionsDisplay';
import ThumbnailStack from './ThumbnailStack';

export type AssetActionsBarProps = {
  actionItems: ActionItem[];
  clearButtonProps: ButtonProps;
  clearButtonText: string;
  clearButtonOnClick: () => void;
  fileName?: string;
};

function AssetActionsBar({
  actionItems,
  clearButtonProps,
  clearButtonText,
  clearButtonOnClick,
  fileName,
}: AssetActionsBarProps) {
  return (
    <Stack direction="row" alignItems="center" width="100%">
      <Box
        sx={{
          flex: '1',
          display: 'flex',
          justifyContent: 'flex-start',
          overflow: 'hidden',
          minWidth: 0,
        }}
      >
        <ThumbnailStack fileName={fileName} />
      </Box>
      <Box sx={{flex: '1', display: 'flex', justifyContent: 'center'}}>
        <ActionsDisplay actionItems={actionItems || []} />
      </Box>
      <Box sx={{flex: '1', display: 'flex', justifyContent: 'flex-end'}}>
        <Button {...clearButtonProps} onClick={clearButtonOnClick}>
          {clearButtonText}
        </Button>
      </Box>
    </Stack>
  );
}

export default AssetActionsBar;
